export default __webpack_public_path__ + "static/media/team47.fd3ffd2b.JPG";